<template>
  <b-row class="variable-select-for-condition">
    <b-col cols="12">
      <label class="mb-2 mr-2">
        <span slot="label-text">
          Select a question variable and operator to validate this question
          total against:
        </span>
      </label>
    </b-col>
    <b-col cols="12">
      <b-btn
        size="sm"
        variant="danger"
        class="mt-2"
        @click="expanded = !expanded"
      >
        Add Rule
      </b-btn>
    </b-col>
    <b-col cols="12" class="mt-2">
      <b-collapse class="text-left" id="vCollapse" v-model="expanded">
        <vue-bootstrap-typeahead
          ref="variableSelector"
          :data="responseValueConditionVariables"
          :serializer="
            (v) =>
              `Q${v.question.id}: ${v.question.prompt} / V${v.id}: ${v.input_label}`
          "
          @hit="addVariable($event)"
          placeholder="Type part of question prompt or variable input label..."
        >
          <template slot="suggestion" slot-scope="{ data }">
            <VariableDisplay :variable="data" />
          </template>
        </vue-bootstrap-typeahead>
      </b-collapse>
    </b-col>

    <b-col cols="12">
      <v-wait :visible="conditionVariablesLoading">
        <div class="text-center" slot="waiting">
          <b-spinner
            variant="success"
            style="width: 3rem; height: 3rem;"
            label="Large Spinner"
          />
        </div>
        <b-row class="mt-3" v-if="selectedVariable">
          <b-col cols="12">
            <VariableDisplay :variable="selectedVariable">
              <i
                slot="remove-icon"
                class="mdi mdi-close-circle-outline size-medium phairify-color-red position-absolute"
                style="right: 5px"
                @click="removeVariable"
              />
            </VariableDisplay>
            <b-row class="mt-1">
              <b-col cols="12">
                <response-validation-operator-selector
                  :variable="selectedVariable"
                  :comparator="comparatorValues[selectedVariable.id]"
                  @update-comparator="onVariableComparatorChange"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </v-wait>
    </b-col>
  </b-row>
</template>

<!-- ----------------------------------------------------------------------- -->

<script>
import VueBootstrapTypeahead from 'vue-typeahead-bootstrap';
import VariableDisplay from '@/components/VariableDisplay.vue';
import ResponseValidationOperatorSelector from '@/components/question/condition/ResponseValidationOperatorSelector';
import { GET_CONDITION_VARIABLES_ACTION } from '@/store/conditionVariables';
import { CONDITION_VARIANTS } from '@/store';

export default {
  name: 'ValueConditionForm',
  components: {
    VueBootstrapTypeahead,
    VariableDisplay,
    ResponseValidationOperatorSelector,
  },
  props: {
    condition: Object,
  },
  data: function () {
    return {
      expanded: false,
    };
  },
  computed: {
    selectedVariableIds: function () {
      return this.condition && Array.isArray(this.condition.condition_variables)
        ? this.condition.condition_variables
        : [];
    },
    selectedVariable: function () {
      return this.responseValueConditionVariables.find(({ id }) =>
        this.selectedVariableIds.includes(id)
      );
    },
    comparatorValues: function () {
      return this.condition && this.condition.comparator_values
        ? this.condition.comparator_values
        : {};
    },
    conditionVariablesLoading: function () {
      return this.$store.state.conditionVariables.loading;
    },
    responseValueConditionVariables: function () {
      return this.$store.getters.responseValueConditionVariables;
    },
  },
  methods: {
    addVariable: function (v) {
      const newCondition = {
        ...(this.condition || {}),
        variant: CONDITION_VARIANTS.RESPONSE_VALIDATION,
        condition_variables: [v.id],
        comparator_values: {
          [v.id]: null,
        },
      };
      this.$emit('set-condition', newCondition);
      this.$refs.variableSelector.inputValue = '';
    },
    removeVariable: function () {
      this.$emit('set-condition', null);
    },
    onVariableComparatorChange: function (variableId, comparator) {
      const newCondition = {
        ...(this.condition || {}),
        variant: CONDITION_VARIANTS.RESPONSE_VALIDATION,
        comparator_values: {
          [variableId]: comparator,
        },
      };
      this.$emit('set-condition', newCondition);
    },
    loadVariables: async function () {
      try {
        await this.$store.dispatch(GET_CONDITION_VARIABLES_ACTION);
      } catch (e) {
        this.$toasted.error('Unable to upload variables for conditions', {
          duration: 3000,
        });
      }
    },
  },
  created: function () {
    if (
      (!Array.isArray(this.responseValueConditionVariables) ||
        this.responseValueConditionVariables.length === 0) &&
      !this.conditionVariablesLoading
    ) {
      this.loadVariables();
    }
  },
};
</script>

<!-- ----------------------------------------------------------------------- -->

<style lang="scss">
@import '../../../../sass/variables_mixins';

.variable-select-for-condition {
  .list-group-item-action {
    color: inherit !important;

    &:hover,
    &:focus-visible {
      background-color: $light-blue;
    }
  }

  i.mdi.mdi-close-circle-outline {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
